import { render, staticRenderFns } from "./TableRiskAppraisalFIRA.vue?vue&type=template&id=e50c2f88&scoped=true"
import script from "./TableRiskAppraisalFIRA.vue?vue&type=script&lang=js"
export * from "./TableRiskAppraisalFIRA.vue?vue&type=script&lang=js"
import style0 from "./TableRiskAppraisalFIRA.vue?vue&type=style&index=0&id=e50c2f88&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e50c2f88",
  null
  
)

export default component.exports